import { Component, Input } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';
import { AfTranslateDirective } from '@shared/modules/translate/directive/af-translate.directive';

@Component({
  selector: 'tooltip-in-report',
  templateUrl: './tooltip-in-report.component.html',
  standalone: true,
  imports: [
    TooltipModule,
    AfTranslateDirective
  ]
})
export class TooltipInReportComponent {
  constructor() { }

  @Input() inReport: any = [];
}
